import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TrnDischargelistService} from './trn-dischargelist.service';
import {TrnDischargelistComponent} from './trn-dischargelist.component';
import {routing} from './trn-dischargelist.routing';
import {TrnAdmissionService} from '../../configuration/trn-admission/trn-admission.service';
import {SharedTranslationModule} from '../../change-language/shared-translation.module';
import {NgxPaginationModule} from 'ngx-pagination';
import {
    ConfirmationService,
    ConfirmDialogModule,
    DialogModule,
    GrowlModule,
    MultiSelectModule,
    PanelModule
} from 'primeng/primeng';
import {OpdPatientConfigService} from '../../configuration/application-configuration/opd-patient-config/opd-patient-config.service';
import {NgxBarcodeModule} from 'ngx-barcode';
import {DischargeService} from '../discharge/discharge.service';
import {DischargeSummaryService} from '../discharge-summary/discharge-summary.service';
import {MipdBedService} from '../../configuration/mipd-bed/mipd-bed.service';
import {MipdWardService} from '../../configuration/mipd-ward/mipd-ward.service';
import {MipdRoomService} from '../../configuration/mipd-room/mipd-room.service';
import {TrnBedStatusService} from '../../configuration/trn-bed-status/trn-bed-status.service';
import {MstClassService} from '../../configuration/mst-class/mst-class.service';
import {TbillBillService} from '../../billing/tbill-bill/tbill-bill.service';
import {BedTransferService} from '../bed-management/bed-transfer/bed-transfer.service';
import {Daterangepicker} from 'ng2-daterangepicker';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ApiRequestService} from '../../shared/api-request-service';

/*import {MstStaffService} from '../mst-staff/mst-staff.service';*/
@NgModule({
    imports: [
        CommonModule,
        ConfirmDialogModule,
        PanelModule,
        routing,
        SharedTranslationModule,
        NgxPaginationModule,
        DialogModule,
        NgxBarcodeModule,
        Daterangepicker,
        ReactiveFormsModule,
        FormsModule
    ],
    declarations: [TrnDischargelistComponent],
    providers: [TrnDischargelistService, ConfirmationService, TrnAdmissionService, OpdPatientConfigService, DischargeService,
        DischargeSummaryService, MipdWardService, MipdBedService, MipdRoomService, TrnBedStatusService, MstClassService, TbillBillService, BedTransferService, ApiRequestService]
})
export class TrnDischargelistModule {
    private static NguiAutoCompleteModule: any;
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/trn-dischargelist/trn-dischargelist.module.ts